var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialmediaf4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82658 0.788312C1.36368 0.941241 1.09322 1.10472 0.755137 1.44749C0.250621 1.95901 0.00616455 2.55491 0.00616455 3.2721C0.00616455 4.33206 0.562693 5.23382 1.49891 5.68206C1.86819 5.86136 1.95141 5.88245 2.43512 5.89827C3.08527 5.92464 3.52217 5.80862 4.00589 5.48167C4.41158 5.20745 4.65604 4.91741 4.87449 4.45862C5.25417 3.66234 5.24377 2.86077 4.85368 2.05921C4.68204 1.70589 4.18273 1.18909 3.82384 0.993976C3.26212 0.688116 2.40392 0.598468 1.82658 0.788312Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4797 7.52249C13.8414 7.7598 12.6867 8.4348 11.9741 9.57913L11.8129 9.83226V7.85999H7.5479V22.3092H12.0157L12.0313 18.0483C12.0521 13.877 12.0521 13.7821 12.1614 13.3866C12.489 12.2159 13.1236 11.6252 14.195 11.5092C15.5838 11.351 16.4159 11.9311 16.7384 13.2758C16.8164 13.5922 16.8268 14.1459 16.8424 17.9692L16.8632 22.3092H21.3363L21.3155 17.3891C21.2947 13.1282 21.2843 12.4057 21.2063 11.9785C20.9254 10.3385 20.3897 9.23108 19.5419 8.53499C18.9853 8.08148 18.3092 7.78616 17.4458 7.62796C17.0141 7.54358 15.771 7.4803 15.4797 7.52249Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.318236 22.3092H4.79127V7.85999H0.318236V22.3092Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmediaf4);
export default __webpack_public_path__ + "static/media/socialmediaf4.341e06a18f0bd8904a40672ec9f98de6.svg";
export { ForwardRef as ReactComponent };